function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default class EventEmitter {
  constructor() {
    _defineProperty(this, "_listeners", []);

    _defineProperty(this, "add", listener => {
      this._listeners.push(listener);

      return () => {
        const index = this._listeners.indexOf(listener);

        if (index !== -1) {
          this._listeners.splice(index, 1);
        }
      };
    });

    _defineProperty(this, "emit", (...args) => {
      this._listeners.forEach(listener => listener(...args));
    });
  }

}